import { useNavigate } from "react-router-dom";
import { ELEMENTS } from "@/data/elements";
import { elementColor } from "@/data/theme";

// Diagrama Wu Xing: geração (linhas cheias, pentágono) e controle (linhas tracejadas, estrela).
// Ordem de geração fiel ao PDF: Madeira → Fogo → Terra → Metal → Água.
const ORDER = ["madeira", "fogo", "terra", "metal", "agua"];

export default function ElementsCycle({ size = 380 }) {
  const navigate = useNavigate();
  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 46;

  const pts = ORDER.map((id, i) => {
    const a = (i / 5) * 2 * Math.PI - Math.PI / 2;
    return { id, x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) };
  });

  const gen = pts.map((p, i) => [p, pts[(i + 1) % 5]]);
  const ctrl = pts.map((p, i) => [p, pts[(i + 2) % 5]]);

  return (
    <div className="flex flex-col items-center gap-4">
      <svg viewBox={`0 0 ${size} ${size}`} className="w-full max-w-sm" role="img" aria-label="Diagrama dos cinco elementos">
        {/* Controle (Ke) - tracejado */}
        {ctrl.map(([a, b], i) => (
          <line key={`k${i}`} x1={a.x} y1={a.y} x2={b.x} y2={b.y} stroke="hsl(var(--gold))" strokeWidth="1.5" strokeDasharray="5 5" opacity="0.55" />
        ))}
        {/* Geração (Sheng) - cheio */}
        {gen.map(([a, b], i) => (
          <line key={`s${i}`} x1={a.x} y1={a.y} x2={b.x} y2={b.y} stroke="#3D6652" strokeWidth="2.5" opacity="0.7" />
        ))}
        {pts.map((p) => {
          const c = elementColor(p.id);
          const el = ELEMENTS.find((e) => e.id === p.id);
          return (
            <g key={p.id} className="cursor-pointer" onClick={() => navigate(`/elementos/${p.id}`)} data-testid={`cycle-node-${p.id}`}>
              <circle cx={p.x} cy={p.y} r="34" fill={c.primary} />
              <text x={p.x} y={p.y + 5} textAnchor="middle" fontSize="14" fontWeight="600" fill="#fff" fontFamily="Playfair Display, serif">
                {el.name}
              </text>
            </g>
          );
        })}
      </svg>
      <div className="flex flex-wrap justify-center gap-5 text-xs">
        <span className="flex items-center gap-2"><span className="inline-block h-0.5 w-6" style={{ background: "#3D6652" }} /> Ciclo de Geração (Sheng)</span>
        <span className="flex items-center gap-2"><span className="inline-block h-0.5 w-6 border-t-2 border-dashed" style={{ borderColor: "hsl(var(--gold))" }} /> Ciclo de Controle (Ke)</span>
      </div>
    </div>
  );
}
